<template>
  <transition name="fade-in" appear>
    <div
      v-if="message && isVisibleOnCurrentRoute"
      class="fixed bottom-6 left-1/2 transform -translate-x-1/2 flex items-center gap-2 px-6 py-4 rounded-lg z-50 w-[90vw] max-w-[400px] shadow-lg overflow-hidden"
      :class="color"
    >
      <img v-if="icon" :src="icon" class="w-6 h-6 flex-shrink-0" :alt="message" />
      <span class="text-white font-aktiv-grotesk text-[16px] leading-[24px] flex-1">{{
        message
      }}</span>
      <div v-if="action || persistent" class="ml-auto flex items-center gap-3 flex-shrink-0">
        <button
          v-if="action"
          class="bg-white text-[#F59E0B] font-aktiv-grotesk-medium text-[13px] px-3 py-1 rounded-full whitespace-nowrap"
          @click="$store.dispatch(action.vuexAction)"
        >
          {{ action.label }}
        </button>
        <button
          v-if="persistent"
          class="bg-white/20 text-white text-[12px] px-3 py-1 rounded-full whitespace-nowrap"
          @click="$store.dispatch('toast/dismiss')"
        >
          Close
        </button>
      </div>

      <!-- Download progress bar, pinned to the toast's bottom edge -->
      <div
        v-if="progress"
        class="absolute left-0 bottom-0 w-full h-1 bg-white/25"
        role="progressbar"
      >
        <div
          v-if="progress.value !== null"
          class="h-full bg-white transition-[width] duration-200 ease-out"
          :style="{ width: progress.value + '%' }"
        ></div>
        <div v-else class="toast-progress-indeterminate h-full w-1/3 bg-white"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import { PHOTODROP_DOWNLOAD_TOAST_SCOPE, QR_WALLET_TOAST_SCOPE } from '@/store/modules/toast';

// A scoped toast only renders on routes containing its mapped path; unscoped toasts show anywhere.
const SCOPE_ROUTES = {
  [PHOTODROP_DOWNLOAD_TOAST_SCOPE]: '/photodrop',
  [QR_WALLET_TOAST_SCOPE]: '/qr-code',
};

export default {
  name: 'Toast',
  computed: {
    ...mapState('toast', ['message', 'icon', 'color', 'scope', 'action', 'persistent', 'progress']),
    // Whitelist: only scoped toasts render, and only on their mapped route. Unscoped
    // toasts (generic API errors etc.) stay hidden to avoid noisy global error popups.
    isVisibleOnCurrentRoute() {
      const routePath = SCOPE_ROUTES[this.scope];
      return !!routePath && this.$route.path.includes(routePath);
    },
  },
};
</script>

<style scoped>
.fade-in-enter-active,
.fade-in-leave-active {
  transition: all 0.3s ease;
}

.fade-in-enter-from,
.fade-in-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}

.fade-in-enter-to,
.fade-in-leave-from {
  opacity: 1;
  transform: translate(-50%, 0);
}

/* Indeterminate download bar: a short segment sliding across the track. */
@keyframes toast-progress-slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(400%);
  }
}
.toast-progress-indeterminate {
  animation: toast-progress-slide 1.1s ease-in-out infinite;
}
</style>
